import React, { useState } from 'react';
import { DEFAULT_ERROR_TEXT } from '@utils';
import { IListingData } from '@models/listing';
import { paymentTermsHeaders } from './content';
import { useLazyQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import ToastErrorMessage from '@components/toast/ToastErrorMessage';
import { mapToListingPaymentTermsData } from './utils';
import { getPolicyBillsThroughBusinessPartnerQuery } from './queries';
import ListingTableWithPagination from '@components/table/with-pagination/ListingTableWithPagination';

const BusinessPartnerPaymentTermsTab: React.FC<{
  businessPartnerId: string;
}> = ({ businessPartnerId }) => {
  const [getBPPolicyBills, { loading }] = useLazyQuery(
    getPolicyBillsThroughBusinessPartnerQuery
  );

  const [tableData, setTableData] = useState<IListingData>({
    pagedItems: {},
    pageSize: 10,
    pageNumber: 1,
    totalCount: 0,
  });

  const onPageChange = async (
    page: number,
    searchKey?: string,
    rowsPerPage?: number,
    order?: string,
    orderBy?: string
  ) => {
    try {
      const { data, error } = await getBPPolicyBills({
        variables: {
          pagination: {
            pageNumber: searchKey ? 1 : page,
            pageSize: rowsPerPage,
          },
          businessPartnerId: businessPartnerId,
          OrderByField: orderBy || 'BusinessPartnerPolicy_PolicyNumber',
          DescendingField: order == 'asc' ? false : true,
          KeywordSearch: searchKey || '',
        },
        errorPolicy: 'all',
      });

      if (error) {
        toast.error(
          <ToastErrorMessage>{DEFAULT_ERROR_TEXT}</ToastErrorMessage>
        );
        return;
      }
      const mappedData = mapToListingPaymentTermsData(
        data?.Accounting?.queries
          ?.GetPolicyBillsThroughBusinessPartnerWithPagination
      );
      setTableData(mappedData);
    } catch (error) {
      toast.error(<ToastErrorMessage>{DEFAULT_ERROR_TEXT}</ToastErrorMessage>);
    }
  };

  return (
    <ListingTableWithPagination
      inlineTitle="Payment Terms Schedule"
      name="paymentTermsSchedule"
      data={tableData}
      headers={paymentTermsHeaders}
      loader={loading}
      inline
      orderByAscendingByDefault
      disableSelection
      actions={[]}
      onPageChange={onPageChange}
    />
  );
};

export default BusinessPartnerPaymentTermsTab;
